







import {Component, Prop, Vue} from "vue-property-decorator";

@Component
export default class PersonMarker extends Vue {
    @Prop()
    verified!: boolean;

    @Prop()
    tooltipAlign!: string;

    @Prop({default: null})
    fontSize!: string | null;

    @Prop({default: false, type: Boolean})
    small!: boolean;

    get alignBottom() {
        return this.tooltipAlign == "bottom";
    }
    get alignLeft() {
        return this.tooltipAlign == "left";
    }
    get alignRight() {
        return this.tooltipAlign == "right";
    }
    get alignTop() {
        return this.tooltipAlign == "top";
    }
    get iconStyle() {
        if(this.fontSize != null) {
            return `font-size: ${this.fontSize}`;
        }
        return "";
    }
}
